export const ACCOUNT_CARD = 'ACCOUNT_CARD';
export const E_STRIPE_ERROR = 'E_STRIPE_ERROR';
export const ACCOUNT_DETAILS = 'ACCOUNT_DETAILS';
export const E_VERIFY_UNKNOWN = 'E_VERIFY_UNKNOWN';
export const E_CARD_GET_UNKNOWN = 'E_CARD_GET_UNKNOWN';
export const E_CARD_ADD_UNKNOWN = 'E_CARD_ADD_UNKNOWN';
export const E_CARD_REMOVE_UNKNOWN = 'E_CARD_REMOVE_UNKNOWN';
export const E_AUTH_INVALID_UNKNOWN = 'E_AUTH_INVALID_UNKNOWN';
export const E_ACCOUNT_UPDATE_UNKNOWN = 'E_ACCOUNT_UPDATE_UNKNOWN';

export const E_ORDERS_NOT_FOUND = 'No orders were found';
export const E_COUNCILS_NOT_FOUND = 'No councils were found.';
export const E_AUTH_UNKNOWN = 'An authentication error occurred';
export const E_ORDER_NOT_FOUND = 'The requested order was not found';
export const E_ADDRESSES_NOT_FOUND = 'No address suggestions were found';
export const E_ORDER_UPDATE_UNKNOWN = 'An error occurred updating the order';
export const E_SET_PASSWORD_UNKNOWN = 'An error occurred setting your password';
export const E_RESET_PASSWORD_UNKNOWN = 'An error occurred resetting your password';
export const E_ORDER_PAYMENT = 'An error occurred while processing payment: ';
export const E_ORDER_UPLOAD_UNKNOWN = 'An unknown error occurred while uploading the document';
export const E_USERS_UNKNOWN = 'An unknown error occurred fetching the account users list';
export const E_USERS_INVITE_UNKNOWN = 'An unknown error occurred sending the invitation.'
export const E_INVITATIONS_UNKNOWN = 'An unknown error occurred fetching user account invitations';
export const E_INVITE_RESPONSE_UNKNOWN = 'An unknown error occurred updating the invitation';
export const E_INVITATION_UNKNOWN = 'An unknown error occurred fetching the invitation';
export const E_CONNECT_UNKNOWN = 'An unknown error occurred connecting the provider';

export const E_ORDER_ITEMS_UNKNOWN = 'An unknown error occurred fetching the order items';

export const E_REGISTRATION_UNKNOWN = 
  'An unknown error occurred during registration';

export const E_COUNCIL_UNKNOWN =
  'An unknown error occured fetching the council details';

export const E_COUNCILS_UNKNOWN =
  'An unknown error occurred fetching the list of councils';

export const E_COUNCIL_NOT_FOUND =
  'No council details were found. Please select another council to process this order.';

export const E_ORDER_CREATE_UNKNOWN =
  'An unknown error occurred while creating the order';

export const E_ORDER_UNKNOWN =
  'An unknown error occurred fetching the order details';

export const E_ORDERS_UNKNOWN =
  'An unknown error occurred fetching the list of orders';

export const E_ADDRESSES_UNKNOWN =
  'An unknown error occurred fetcing address suggestions';

export const E_ADDRESS_SEARCH_NOT_FOUND =
  'No address matches were found. Please check the address details are correct and try again.';

export const E_ADDRESS_SEARCH_UNKNOWN =
  'An error occurred looking up the address details';

export const E_EMPTY_ADDRESS_MATCHES = {
  message: 'No address matches were found for the requested address.',
  type: 'warning',
  code: 'E_EMPTY_ADDRESS_MATCHES'
};

export const E_OAUTH_CLIENT_UNKNOWN = 'An unknown error occurred fetching the client details';
export const E_OAUTH_AUTH_UNKNOWN = 'An unkown error occurred authenticating the client';

export const E_STRATA_UNKNOWN =
  'An unknown error occured fetching the strata details';

export const E_STRATAS_UNKNOWN =
  'An unknown error occurred fetching the list of strata management companies';

export const E_STRATA_NOT_FOUND =
  'No strata details were found. Please select another strata management company to process this order.';

export const E_STRATAS_NOT_FOUND =
  'No strata management companies were returned. An error has occurred.'